import styled from '@emotion/styled';
import { spacing } from 'component-library';

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing.small};
`;
